import { CollectionProps } from "@bluebottlecoffee/design-system/components";
import { FacetCategoryResult } from "../sanity/shop-queries";

export interface FacetFiltersCopy {
  triggerButtonFiltersLabel: string;
  dismissFiltersLabel: string;
  clearAllFiltersLabel: string;
  applyFiltersLabel: string;
  filtersTitle: string;
  sortByLabel: string;
  priceLowToHighLabel: string;
  priceHighToLowLabel: string;
}

/**
 * Converts Sanity facetFilters into the shape expected by the design system's
 * Collection `filterProps`. Each category becomes a filter group and its
 * associated facetValues become the selectable options.
 */
export const toFacetFiltersProps = (
  facetFilters: FacetCategoryResult[],
  copy: FacetFiltersCopy,
): CollectionProps["filterProps"] => ({
  ...copy,
  filters: facetFilters.map(({ slug, display, values }) => ({
    id: slug,
    label: display,
    options: values.map(({ slug: id, display: label }) => ({ id, label })),
  })),
});

export const toSortProps = (
  copy: FacetFiltersCopy,
): CollectionProps["sortProps"] => ({
  label: copy.sortByLabel,
  options: [
    { id: "priceLowToHigh", label: copy.priceLowToHighLabel },
    { id: "priceHighToLow", label: copy.priceHighToLowLabel },
  ],
});
